export const CART_REMOVE_FROM_CART_SOURCE = {
    CART_PAGE: 'cartPage',
    MINI_CART: 'miniCart',
    MATERIAL_CARD: 'materialCard'
} as const;

export type CartRemoveFromCartSource = (typeof CART_REMOVE_FROM_CART_SOURCE)[keyof typeof CART_REMOVE_FROM_CART_SOURCE];
